import FacebookIcon from '@raisin/components-lib/Icons/Facebook';
import InstagramIcon from '@raisin/components-lib/Icons/Instagram';
import LinkedInIcon from '@raisin/components-lib/Icons/Linkedin';
import XIcon from '@raisin/components-lib/Icons/X';
import YoutubeIcon from '@raisin/components-lib/Icons/Youtube';
import React from 'react';
export const SocialIcons = {
    Facebook: React.createElement(FacebookIcon, { color: "black100", sx: { width: 24, height: 30 } }),
    LinkedIn: React.createElement(LinkedInIcon, { color: "black100", sx: { width: 30, height: 30 } }),
    Twitter: React.createElement(XIcon, { color: "black100", sx: { width: 30, height: 30 } }),
    Youtube: React.createElement(YoutubeIcon, { color: "black100", sx: { width: 30, height: 30 } }),
    Instagram: React.createElement(InstagramIcon, { color: "black100", sx: { width: 24, height: 30 } }),
};
//# sourceMappingURL=icons.js.map